import Axios from "axios";

export const SelectBC = (f, g, a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/BCDVCLIs?type=BC&vendeur=${f}&grp=${g}&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "BC_SELECT", payload: response.data });
    });
  };
};
